import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Hero from '../components/home/Hero';
import AguinaldoPromo from '../components/home/AguinaldoPromo';
import ChristmasCarousel from '../components/home/ChristmasCarousel';
import FeaturedSeriesPromo from '../components/home/FeaturedSeriesPromo';
import JourneySection from '../components/home/JourneySection';
import ServiceMarketing from '../components/home/ServiceMarketing';

// Category pages linked from the home page, so Google ties "bicicletas" searches to this site.
const CATEGORIES = [
    { to: '/bicicletas-electricas-santo-domingo', label: 'Bicicletas eléctricas', text: 'Pedaleo asistido para ciudad, montaña y trekking' },
    { to: '/bicicletas-de-montana-santo-domingo', label: 'Bicicletas de montaña', text: 'Rígidas y doble suspensión, aro 29 y 27.5' },
    { to: '/bicicletas-de-ruta-y-gravel-santo-domingo', label: 'Ruta y gravel', text: 'Para carretera, caminos y largas distancias' },
    { to: '/bicicletas-para-ninos-santo-domingo', label: 'Bicicletas para niños', text: 'Tallas por edad y estatura' },
    { to: '/comprar-bicicleta-santo-domingo', label: 'Comprar bicicleta', text: 'Precios desde, tallas y cómo elegir' },
    { to: '/taller-de-bicicletas-santo-domingo', label: 'Taller de bicicletas', text: 'Lavado y mantenimiento desde RD$500' }
];

const Home = () => {
    return (
        <main>
            <Hero />
            <AguinaldoPromo />
            <ChristmasCarousel />
            <FeaturedSeriesPromo />
            <JourneySection />
            <ServiceMarketing />

            <section className="bg-white py-20">
                <div className="max-w-[1600px] mx-auto px-6 md:px-12">
                    <h2 className="text-3xl md:text-5xl font-black italic uppercase tracking-tight mb-6">
                        Tienda de bicicletas <span className="gradient-text-dark">en Santo Domingo</span>
                    </h2>
                    <p className="text-gray-600 max-w-3xl text-base md:text-lg leading-relaxed mb-10">
                        En PROO MTB &amp; ROAD vendemos bicicletas Raymon en Los Prados, Santo Domingo: bicicletas eléctricas,
                        de montaña, de ruta, gravel, trekking y para niños. Somos distribuidor oficial de Raymon en República
                        Dominicana. En la tienda pruebas tu talla y haces una prueba de manejo, nuestro taller se encarga del
                        mantenimiento y enviamos a todo el país.
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        {CATEGORIES.map((item) => (
                            <Link key={item.to} to={item.to} className="group flex items-center justify-between gap-4 bg-zinc-50 rounded-2xl border border-zinc-200 p-6 hover:border-black transition-colors">
                                <div>
                                    <div className="font-black uppercase tracking-tight">{item.label}</div>
                                    <div className="text-sm text-gray-500">{item.text}</div>
                                </div>
                                <ArrowRight className="w-5 h-5 shrink-0 group-hover:translate-x-1 transition-transform" />
                            </Link>
                        ))}
                    </div>
                </div>
            </section>

            {/* Short Brand Statement Section (common in Raymon) */}
            <section className="bg-raymon-gray py-24">
                <div className="max-w-4xl mx-auto px-4 text-center">
                    <h2 className="text-4xl md:text-5xl font-black italic uppercase tracking-tight mb-8 leading-none">
                        German Performance.<br />
                        <span className="gradient-text-dark">Global Passion.</span>
                    </h2>
                    <p className="text-lg text-gray-600 leading-relaxed overflow-hidden">
                        RAYMON es más que una marca de bicicletas. Es una invitación a explorar, a superar límites y a redescubrir el mundo sobre dos ruedas.
                        Cada modelo está diseñado con precisión alemana y un enfoque obsesivo en la calidad y el rendimiento.
                    </p>
                </div>
            </section>
        </main>
    );
};

export default Home;
